import { render } from "./TargetingTypeValue.vue?vue&type=template&id=e495b354&scoped=true"
import script from "./TargetingTypeValue.vue?vue&type=script&lang=js"
export * from "./TargetingTypeValue.vue?vue&type=script&lang=js"

import "./TargetingTypeValue.vue?vue&type=style&index=0&id=e495b354&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e495b354"]])

export default __exports__